/**
 * ExerciseCard Component
 * 
 * Displays an exercise with thumbnail, title, and duration.
 * Clicking opens the video (placeholder functionality).
 * 
 * Props:
 * - exercise: Object containing title, thumbnail, description, duration, videoUrl
 */

import { Play } from 'lucide-react'

const ExerciseCard = ({ exercise }) => {
  return (
    <article className="group cursor-pointer">
      {/* Thumbnail with Play Overlay */}
      <div className="relative aspect-video overflow-hidden rounded-sm mb-3">
        <img
          src={exercise.thumbnail}
          alt={exercise.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        
        {/* Play Button Overlay */}
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
            <Play className="w-8 h-8 text-brand-orange-500 ml-1" fill="currentColor" />
          </div>
        </div>

        {/* Duration Badge */}
        <span className="absolute bottom-2 right-2 px-2 py-1 bg-black/70 text-white text-xs font-sans rounded">
          {exercise.duration}
        </span>
      </div>

      {/* Title */}
      <h3 className="font-display text-lg text-gray-800 font-medium group-hover:text-brand-orange-500 transition-colors">
        {exercise.title}
      </h3>

      {/* Description */}
      <p className="font-body text-gray-500 text-base mt-1 line-clamp-2">
        {exercise.description}
      </p>
    </article>
  )
}

export default ExerciseCard
